import * as d3 from "d3";
import {colonAnnotation, make_x_gridlines, numberFormat, responsivefy} from '../functions'

export default function (chart, divId, vizName, resData, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //  var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    // axios.post(url, filterParam).then(res => {
    //     console.log("Chart vizName called:", vizName, filterParam)

        let data = resData
        let dim2 = data[0].dim2
        let metric = data[0].metric

        var width = chart.width, height = chart.height / 3,
            groupHeight = height * data[0].metric.length,
            gapBetweenGroups = 10,
            spaceForLabels = 200,
            spaceForLegend = 150;
        console.log("data: ", data)
        console.log("hgbc data[0].dim2: ", data[0].dim2)
        console.log("hgbc data[0].metric: ", data[0].metric)
        // Zip the series data together (first values, second values, etc.)
        var zippedData = [];
        for (var i = 0; i < data[0].dim2.length; i++) {
            for (var j = 0; j < metric.length; j++) {
                zippedData.push(metric[j].values[i]);
            }
        }
        console.log(zippedData);
        // color scale
        var metric1ColorScale = d3.scaleOrdinal(['#9911bb', '#6633bb', '#00aaff', '#00bbdd', '#009988', '#44bb44', '#88cc44',
            '#ccdd22', '#ffee11', '#ffcc00', '#ff9900', '#ff5500', '#775544', '#999999', '#828080', '#444', '#ff4422', '#ee1166']);
        var chartHeight = height * zippedData.length + gapBetweenGroups * dim2.length;
        console.log("chartH", chartHeight)

        var x1Scale = d3.scaleLinear().domain([0, d3.max(zippedData)]).range([0, width]);
        var y1Scale = d3.scaleLinear().range([chartHeight + gapBetweenGroups, 0]);

        var x1AxisLabel = d3.axisBottom(x1Scale).tickFormat((d) => {
            return d
        });
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat('').tickSize(0);

        // Specify the chart area and dimensions
        var svg = d3.select(divId).selectAll("*").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr("width", spaceForLabels + width + spaceForLegend)
            .attr("height", chartHeight + 30)
            .call(responsivefy);

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        // Create bars
        var bar = svg.selectAll("g")
            .data(zippedData)
            .enter()
        //  .append("g")


        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                // .attr("transform", "translate(0," + chart.height + ")")
                .attr("transform", "translate(" + spaceForLabels + "," + chartHeight + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSize(-chartHeight)
                    .tickFormat(""))

            // add the Y gridlines
            /*  svg.append("g")
                       .attr("class", "grid")
                       .call(make_y_gridlines(y1Scale)
                           .tickSize(-chart.width)
                           .tickFormat(""))*/
        }
        // Create rectangles of the correct width
        bar.append("rect")
            .attr("transform", function (d, i) {
                return "translate(" + spaceForLabels + "," + (i * height + gapBetweenGroups * (0.5 + Math.floor(i / metric.length))) + ")";
            })
            .attr("fill", function (d, i) {
                return metric1ColorScale(i % metric.length);
            })
            .attr("class", "bar")
            .attr("width", x1Scale)
            .attr("height", height - 1)
            .on("mousemove", function (d, i) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(dim2[Math.floor(i / metric.length)] + colonAnnotation + numberFormat(d))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });

        // Draw labels
        bar.append("text")
            .attr("transform", function (d, i) {
                return "translate(" + spaceForLabels + "," + (i * height + gapBetweenGroups * (0.5 + Math.floor(i / metric.length))) + ")";
            })
            .attr("text-anchor", "start")
            .attr("x", -10)
            .attr("y", groupHeight / 2)
            .attr("dy", ".1em")
            .attr("dx", "-8em")
            .text(function (d, i) {
                if (i % metric.length === 0)
                    return dim2[Math.floor(i / metric.length)].substring(0, 15) + " ~";
                else {
                    return " "
                }
            });

        svg.append("g")  // Add the X Axis
            .attr("class", "x axis")
            .attr("transform", "translate(" + spaceForLabels + "," + chartHeight + ")")
            .call(x1AxisLabel)
            .style('font-size', axisLabelFontSize);

        svg.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(" + spaceForLabels + ", " + -gapBetweenGroups / 2 + ")")
            .call(y1AxisLabel)
            .style('font-size', axisLabelFontSize);

        /*svg.append('text')
                 .attr('x', (width / 2))
                 .attr('y', 0- height+ 2*chart.axisLabelDistance)
                 .style('fill', fontColor)
                 .text(chart.x1AxisDisplayName)
                 .style('font-size',fontSize)*/

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - 4 * chart.axisLabelDistance + 20)
            .attr('x', 0 - (chartHeight / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        // Draw legend
        var legendRectSize = 18,
            legendSpacing = 4;

        var y1legend = svg.selectAll('.legend')
            .data(metric)
            .enter()
            .append('g')
            .attr('transform', function (d, i) {
                var height = legendRectSize + legendSpacing;
                var offset = -gapBetweenGroups / 2;
                var horz = spaceForLabels + width + 40 - legendRectSize;
                var vert = i * height - offset;
                console.warn(d)
                return 'translate(' + horz + ',' + vert + ')';
            });

        y1legend.append('rect')
            .attr('width', legendRectSize)
            .attr('height', legendRectSize)
            .style('fill', function (d, i) {
                return metric1ColorScale(i);
            })
            .style('stroke', function (d, i) {
                return metric1ColorScale(i);
            });

        y1legend.append('text')
            .attr('class', 'legend')
            .attr('x', legendRectSize + legendSpacing)
            .attr('y', legendRectSize - legendSpacing)
            .text(function (d) {
                return d.label;
            });

    // });
}
